import React, { useState } from 'react';
import './LoginForm.css';

const LoginForm = ({ onLogin, error: authError, loading, title, subtitle, note }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email || !formData.password) {
      return;
    }

    setIsSubmitting(true);
    try {
      await onLogin(formData.email, formData.password);
    } catch (error) {
      // Error handled by useAuth hook
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-form-container">
      <div className="login-header">
        <h2>{title || 'Sign In to Delete Your Account'}</h2>
        <p>{subtitle || 'Please sign in to verify your identity before proceeding with account deletion.'}</p>
      </div>

      <form onSubmit={handleSubmit} className="login-form">
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
            placeholder="Enter your email"
            disabled={isSubmitting}
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleInputChange}
            required
            placeholder="Enter your password"
            disabled={isSubmitting}
          />
        </div>

        {authError && (
          <div className="error-message">
            {authError}
          </div>
        )}

        <button
          type="submit"
          className="btn-primary"
          disabled={isSubmitting || !formData.email || !formData.password}
        >
          {isSubmitting ? 'Signing In...' : 'Sign In'}
        </button>
      </form>

      {note && (
        <div className="login-footer">
          <p>
            <strong>Note:</strong> {note}
          </p>
        </div>
      )}
    </div>
  );
};

export default LoginForm;